// removed by extract-text-webpack-plugin
module.exports = {"blcError":"ErrorBox__blcError___1Iwi_"};


//////////////////
// WEBPACK FOOTER
// ./src/common/ErrorBox/ErrorBox.scss
// module id = 727
// module chunks = 0